import {Theme} from "@emotion/react";
import {SearchOff} from "@mui/icons-material";
import * as React from "react";
import {Stack, SvgIconOwnProps, SxProps, Typography} from "@mui/material";
import {translate} from "@util";
import {useDownBreakpoint} from "@hooks";

const EmptyData = ({
  sx,
  Icon,
  message,
}: {
  sx?: SxProps<Theme>;
  Icon?: React.ComponentType<SvgIconOwnProps>;
  message?: string;
}) => {
  const isDownSm = useDownBreakpoint("sm");
  const fontSize = isDownSm ? 40 : 60;
  const variant = isDownSm ? "body2" : "h6";

  const DefaultIcon = SearchOff;
  const IconToUse = Icon ?? DefaultIcon;

  return (
    <Stack
      className="empty-data-container"
      direction="column"
      alignItems="center"
      gap={1}
      flex={"1 1 0"}
      justifyContent={"center"}
      sx={sx}>
      <IconToUse color="action" sx={{fontSize}} />
      <Typography color="textPrimary" variant={variant} textAlign={"center"}>
        {message ?? translate("common.table.noRowsLabel")}
      </Typography>
    </Stack>
  );
};

export {EmptyData};
